import { render } from "./SectionOfficialBusiness.vue?vue&type=template&id=2e2cb69c&scoped=true"
import script from "./SectionOfficialBusiness.vue?vue&type=script&lang=js"
export * from "./SectionOfficialBusiness.vue?vue&type=script&lang=js"

import "./SectionOfficialBusiness.vue?vue&type=style&index=0&id=2e2cb69c&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e2cb69c"]])

export default __exports__